export type FirebaseConfig = {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
};

export type Environment = {
  env: "dev" | "prod" | "staging";
  chatBotUrl: string;
  liveChatUrl: string;
  apiUrl: string;
  wsDomain: string;
  production: boolean;
  firebaseConfig: FirebaseConfig;
  firebaseVapidKey: string;
  firebaseTokenId: string;
  sentryDsn: string;
  sentryWhitelistHosts: (string | RegExp)[];
  posthogApiKey: string;
  posthogHost?: string;
  posthogWhitelistHosts: (string | RegExp)[];
  geocodingKey: string;
  mapTilerKey: string;
  agoraAppId: string;
  klipyApiKey: string;
  chatBotToken: string;
  isReCaptchaEnabled: boolean;
  reCaptchaKey: string;
  guestUrl: string;
  facebookConfigId: string;
  featureFlags: {
    maxChatAttachmentsCount: number;
    isGmailAuthEnabled: boolean;
  };
  escapeChatChars: boolean;
  demoToken?: string;
  isDemo?: boolean;
  isWDIREnabled?: boolean;
  instagramClientId: string;
  shopifyClientId: string;
};

// DEV

export const devApiUrl = "https://api-dev.jugl.com";

export const devWsDomain = "api-dev.jugl.com";

export const devFirebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyBRxeHe9et0iQSg8hjqABHLneRB16KpKpw",
  authDomain: "joiint-dev.firebaseapp.com",
  projectId: "joiint-dev",
  storageBucket: "joiint-dev.appspot.com",
  messagingSenderId: "575187276418",
  appId: "1:575187276418:web:2f89ba70d82ce3532dda9b",
  measurementId: "G-2328P2KTQ6",
};

export const devFirebaseVapidKey =
  "BM6ys8ozWaGT4ekoj8HSsQ5oUQbPcn9IYGOt9z8TV2y1eDkNERdwEnBj20uzOeFDCRKlBxE3dNiksCrKnO39CWA";

export const devFirebaseTokenId = "com.jugl.web.dev";

export const devAgoraAppId = "3dde46fad16d4a7b9a9e9f0376306dd8";

export const devKlipyApiKey =
  "2k7jFaxeaSFrQrZrQH0x5BwhzcdqiFIClNcpOOPEaAroguvyDrNgd07FIxDuUXk5";

export const devFacebookConfigId = "2554358828103000";

// PROD

export const prodApiUrl = "https://api.jugl.com";

export const prodWsDomain = "api.jugl.com";

export const prodFirebaseConfig: FirebaseConfig = {
  apiKey: "AIzaSyDPmgfYvohtmlOEehI-3yT0QiJ7hnYiwsY",
  authDomain: "joiint-prod.firebaseapp.com",
  projectId: "joiint-prod",
  storageBucket: "joiint-prod.appspot.com",
  messagingSenderId: "1005857424797",
  appId: "1:1005857424797:web:d24a8b57b9a789a6e21b74",
  measurementId: "G-S1Z092BL1C",
};

export const prodFirebaseVapidKey =
  "BNFS9GATzcBtaCvS19S-Zc751ZD9rM3mkbvMSBtPsP1iiTBhf1yODVABGmX7NganW2t37XYQUIdPyPb6-OZZMWE";

export const prodFirebaseTokenId = "com.jugl.web";

export const prodAgoraAppId = "1fbe2021f4724da9b1681c7141f3bf2d";

export const prodKlipyApiKey =
  "2k7jFaxeaSFrQrZrQH0x5BwhzcdqiFIClNcpOOPEaAroguvyDrNgd07FIxDuUXk5";

export const stagingFacebookConfigId = "1397224691291862";

export const prodFacebookConfigId = "507521708941738";

// STAGING

export const stagingApiUrl = "https://api-stg.jugl.com";

export const stagingWsDomain = "api-stg.jugl.com";

// SHARED

export const geocodingKey = atob(
  "QUl6YVN5RFFBMGRkUEl1MGEwcG83U3J5eVRRS3NGMWFaQ1lpMHk4"
);

export const mapTilerKey = "wwdtIt0Gsl8LTfzBIHve";
